import { 
    CREATEHOSPITALEDOWNLOAD, 
    DELETEHOSPITALEDOWNLOAD, 
    GETHOSPITALEDOWNLOAD, 
    UPDATEHOSPITALEDOWNLOAD 
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEHOSPITALEDOWNLOAD:
            return {
                ...state,
                hospitaledownloadSaveStatus: action.payload.success,
            }
        case GETHOSPITALEDOWNLOAD:
                return {
                        ...state,
                        hospitaledownloadList: action.payload.data,
                        }
        case UPDATEHOSPITALEDOWNLOAD:
                return {
                        ...state,
                        hospitaledownloadUpdateStatus: action.payload.success,
                        }   

        case DELETEHOSPITALEDOWNLOAD:
                 return {
                     ...state,
                     hospitaledownloadDeleteStatus: action.payload.success,
                        }
                        default:
                            return state
                             }
                         }